/** @jsx jsx */
import type { ReactNode } from 'react';

import { css, jsx } from '@emotion/react';

import { token } from '@atlaskit/tokens';

const gridLayoutStyles = css({
  display: 'grid',
  justifyContent: 'flexStart',
  gap: token('space.200', '16px'),
  gridAutoRows: 'max-content',
});

interface GridLayoutProps {
  children: ReactNode;
  columns: 1 | 2 | 3;
}

/**
 * __Grid layout__
 *
 * A grid layout displays content in 1, 2 or 3 columns.
 *
 */
const GridLayout = ({ columns, children }: GridLayoutProps) => {
  const gridTemplateColumnsStyles = css({
    gridTemplateColumns: `repeat(${columns}, 1fr)`,
  });

  return (
    <div css={[gridLayoutStyles, gridTemplateColumnsStyles]}>{children}</div>
  );
};

export default GridLayout;
